import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Switch, Route, Redirect } from 'react-router-dom';

import { getReturnObject, returnsDisabled } from '../../helpers/returns';
import { resetConfirmation } from '../../actions/order';
import { fetchNewLabel } from '../../actions/label';
import { sendPageloadEvent } from '../../actions/adobe';
import { getReturnConfirmationTrackingData } from '../../helpers/adobe';

import ReturnsDetailStatus from '../../components/return-detail/ReturnsDetailStatus';
import ReturnDetailConfirmation from '../../components/return-detail/ReturnDetailConfirmation';
import { RETURNS_CONFIRMATION_ID, RETURNS_ORDER_DETAIL, RETURNS_DOWNTIME } from '../../helpers/routes';
import { transformServices } from '../../helpers/services';

class ReturnsDetail extends Component {
  componentDidMount() {
    const { handleSendPageloadEvent, returnData, match } = this.props;

    handleSendPageloadEvent(match, getReturnConfirmationTrackingData(returnData));
  }

  render() {
    if (returnsDisabled()) {
      return <Redirect to={RETURNS_DOWNTIME} />;
    }

    return (
      <Switch>
        <Route
          exact
          path={RETURNS_CONFIRMATION_ID}
          render={() => <ReturnDetailConfirmation {...this.props} />}
        />
        <Route
          exact
          path={RETURNS_ORDER_DETAIL}
          render={() => <ReturnsDetailStatus {...this.props} />}
        />
      </Switch>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const returnData = state.returns.returns.find(returnItem => (
    returnItem.returnOrderId === ownProps.match.params.id
  ));
  const accountData = state.account?.data;

  const { devices = {} } = transformServices(
    {
      dsmDevices: state.devices.services,
      returns: state.returns,
      accountData,
    },
  );

  return {
    returnData: returnData && getReturnObject(returnData, { devices: Object.values(devices) }),
    newLabelLoading: state.returns.newLabelLoading,
    email: state.account.data.preferredEmail,
  };
};

const mapDispatchToProps = dispatch => ({
  handleFetchNewLabel: bindActionCreators(fetchNewLabel, dispatch),
  handleResetConfirmation: bindActionCreators(resetConfirmation, dispatch),
  handleSendPageloadEvent: bindActionCreators(sendPageloadEvent, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReturnsDetail);
